import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=48ce752d&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=48ce752d&prod&lang=css"
import style1 from "./Email.vue?vue&type=style&index=1&id=48ce752d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce752d",
  null
  
)

export default component.exports